import { CloseOutlined} from "@ant-design/icons";
import { Avatar} from "antd";
import { Col, Modal, Row } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import "../utils/detail.css";
import CardImageItem from "../../../../common/image/cardImage";

const DetailBusiness = ({ modal, setModal, toggle, selectedMerchent, currentuser }) => {
  const { fisrtName, lastName, sectorName, country, description, logo, businessRegistry, apiKey, apiToken, documents = []} = selectedMerchent || {};

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      onCancel={toggle}
      centered
      backdrop="static"
      style={{ maxWidth: "900px" }}
    >
      <div className="modal-content-custom">
        <div className="modal-header-custom">
          <h1 className="title-detail-modal">Détail du marchand {fisrtName+" "+lastName}</h1>
          <CloseOutlined className="close-btn" onClick={() => setModal(false)}/>
        </div>
        <Row>
          <div className="detail-div">
            <Row className="info-User">
              <Col lg={2} className="logo-container mt-2 mb-4">
                <Avatar size={80}>
                  <CardImageItem fileName={logo} token={currentuser?.token} />
                </Avatar>
              </Col>
              <div>
                <table className="recap-table">
                  <thead>
                    <tr>
                      <th>Business</th>
                      <th>Transaction</th>
                      <th>Pays</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{lastName || "-"}</td>
                      <td>{sectorName || "-"}</td>
                      <td>{country || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Row>
          </div>
        </Row>
      </div>
    </Modal>
  );
};

export default DetailBusiness;
